import { render, staticRenderFns } from "./electronic_fence.vue?vue&type=template&id=6f89c1c0&scoped=true&"
import script from "./electronic_fence.vue?vue&type=script&lang=js&"
export * from "./electronic_fence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f89c1c0",
  null
  
)

export default component.exports